import {useListView} from '../../core/ListViewProvider'
import {GroupPricingsListToolbar} from './GroupPricingListToolbar'
import {GroupPricingsListGrouping} from './GroupPricingsListGrouping'
import {GroupPricingsListSearchComponent} from './GroupPricingsListSearchComponent'

const GroupPricingsListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='card-header border-0 pt-6'>
      <GroupPricingsListSearchComponent />
      {/* begin::Card toolbar */}
      <div className='card-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <GroupPricingsListGrouping /> : <GroupPricingsListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Card toolbar */}
    </div>
  )
}

export {GroupPricingsListHeader}
